/**
 * Source of truth for all query keys
 */
export const queryKeys = {
   authStatus: ['authStatus'],
   featurePermissions: ['featurePermissions'],
   integrationObjects: ['integrationObjects'],
   termLengths: ['termLengths'],
   prepayLengths: ['prepayLengths'],
   pricebooks: ['pricebooks'],
   currency: (currencyCode: string) => ['currency', currencyCode],
   products: (pricebookId: string, currencyCode: string) => [
      'products',
      pricebookId,
      currencyCode,
   ],
   prevProducts: (prevPricebookId: string, currencyCode: string) => [
      'prevProducts',
      prevPricebookId,
      currencyCode,
   ],
   discounts: (
      pricebookId: string,
      currencyCode: string,
      accountSnowflake: string,
   ) => ['discounts', pricebookId, currencyCode, accountSnowflake],
   getOpportunity: ['getOpportunity'],
   time: ['time'],
   dealDeskDiscounts: (opportunityId: string) => [
      'dealDeskDiscounts',
      opportunityId,
   ],
   pricingAdjustments: (
      bookId: string,
      currencyCode: string,
      accountSnowflake: string,
   ) => ['pricingAdjustments', bookId, currencyCode, accountSnowflake],
}
